import CardModule from './card.module'

export default CardModule
